// extracted by mini-css-extract-plugin
var _1 = "ExpandedPostModalMagneticWall-module__annotation--UMwra";
var _2 = "ExpandedPostModalMagneticWall-module__container--loy3b";
export { _1 as "annotation", _2 as "container" }
